// Messages/ThreadsList.jsx
// Component for displaying list of message threads

import React from 'react';
import { styles } from './styles';
import ThreadCard from './ThreadCard';
import EmptyState from './EmptyState';

const ThreadsList = ({ threads, userInfos, currentUserId, onThreadClick }) => {
  if (threads.length === 0) {
    return <EmptyState />;
  }

  return (
    <div style={styles.threadsList}>
      {threads.map((thread) => {
        const otherUid = (thread.participants || []).find(uid => uid !== currentUserId);
        const userInfo = userInfos[otherUid];
        
        return (
          <ThreadCard
            key={thread.id}
            thread={thread}
            userInfo={userInfo}
            currentUserId={currentUserId}
            onThreadClick={onThreadClick}
          />
        );
      })}
    </div>
  );
};

export default ThreadsList;